export default "skymp5-front/e406b60e9b44524ddc6e8398a1b56ea6.png";